import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import { country_code_list } from './Functions';
import '../../entity-forms.css';

const CITIES = ['Dubai','Abu Dhabi','Sharjah','Ajman','Ras Al Khaimah','Fujairah','Umm Al Quwain'];

export default function Homebase() {
  const API_URL = process.env.REACT_APP_API_URL;

  const [data, setdata]             = useState([]);
  const [isload, setisload]         = useState(true);
  const [teams, setteams]           = useState([]);
  const [search, setSearch]         = useState('');

  const initForm = { user: sessionStorage.getItem('userid') };
  const [form, setForm]             = useState(initForm);
  const [isEdit, setIsEdit]         = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [msg, setMsg]               = useState('');
  const [errMsg, setErrMsg]         = useState('');

  useEffect(() => { loadList(); loadTeams(); }, []);

  const loadList = async () => {
    setisload(true);
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/homebase/getHomebases`);
      if (res.data.data) setdata(res.data.data);
    } catch {}
    setisload(false);
  };

  const loadTeams = async () => {
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/team/getTeams`);
      if (res.data.data) setteams(res.data.data);
    } catch {}
  };

  const openAdd  = () => { setForm(initForm); setIsEdit(false); setMsg(''); setErrMsg(''); setDrawerOpen(true); };
  const openEdit = (row) => { setForm({ ...row }); setIsEdit(true); setMsg(''); setErrMsg(''); setDrawerOpen(true); };
  const closeDrawer = () => { setDrawerOpen(false); setForm(initForm); };

  const validate = () => {
    if (!form.homebaseName || !form.homebaseType || !form.teams || !form.place || !form.address ||
        !form.locality || !form.city || !form.contactPerson || !form.latitude || !form.longitude) {
      setMsg('Please fill all required fields (*)');
      return false;
    }
    setMsg('');
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    try {
      const payload = { ...form, updatedBy: sessionStorage.getItem('userid'), status: 'Active' };
      const url = isEdit
        ? `${API_URL}shypvdriverapp/homebase/updateHomebase`
        : `${API_URL}shypvdriverapp/homebase/createHomebase`;
      const res = await axios.post(url, payload, { headers: { 'Content-Type': 'application/json' } });
      if (res.data.success) { closeDrawer(); loadList(); }
      else setMsg('Operation failed. Please try again.');
    } catch (e) { setErrMsg('Server error: ' + (e.response?.data?.message || e.message)); }
  };

  const handleDelete = async () => {
    if (!selectedIds.length) return;
    if (!window.confirm(`Delete ${selectedIds.length} homebase(s)?`)) return;
    try {
      const res = await axios.delete(`${API_URL}shypvdriverapp/homebase/deleteHomebase`, {
        headers: { 'Content-Type': 'application/json' },
        data: { homebaseCodes: selectedIds },
      });
      if (res.data.success) { setSelectedIds([]); loadList(); }
      else setErrMsg('Delete failed');
    } catch { setErrMsg('Error deleting homebase'); }
  };

  const toggleSelect = (code, row) => {
    setSelectedIds(prev => {
      if (prev.includes(code)) { const next = prev.filter(x => x !== code); if (!next.length) setForm(initForm); return next; }
      setForm(row); return [...prev, code];
    });
  };

  const filtered = data.filter(r =>
    !search ||
    r.homebaseName?.toLowerCase().includes(search.toLowerCase()) ||
    r.homebaseCode?.toLowerCase().includes(search.toLowerCase())
  );

  const role = sessionStorage.getItem('role');
  const canDelete = role === 'super_admin' || role === 'admin';

  return (
    <div style={{ fontFamily:"'Poppins', sans-serif" }}>
      <div className="em-action-bar">
        <div className="em-search-wrap">
          <i className="fa fa-search" />
          <input className="em-search" placeholder="Search homebases…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <button className="em-btn em-btn-primary" onClick={openAdd}><i className="fa fa-plus" /> Add Homebase</button>
        {selectedIds.length === 1 && (
          <button className="em-btn em-btn-warning" onClick={() => openEdit(form)}><i className="fa fa-pencil" /> Edit</button>
        )}
        {selectedIds.length > 0 && canDelete && (
          <button className="em-btn em-btn-danger" onClick={handleDelete}><i className="fa fa-trash" /> Delete ({selectedIds.length})</button>
        )}
        <CSVLink data={filtered} filename="homebases.csv" className="em-btn em-btn-csv"><i className="fa fa-download" /> Export</CSVLink>
        {errMsg && <span className="em-msg-error">{errMsg}</span>}
      </div>

      <div style={{ overflowX:'auto' }}>
        <table className="em-table">
          <thead>
            <tr>
              <th className="em-col-h" style={{ width:36 }}>
                <input type="checkbox" onChange={e => setSelectedIds(e.target.checked ? filtered.map(r => r.homebaseCode) : [])}
                  checked={selectedIds.length > 0 && selectedIds.length === filtered.length} />
              </th>
              {['Code','Name','Type','Team','City','Contact','Lat','Lng','Actions'].map(h => <th key={h} className="em-col-h">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {isload ? (
              <tr><td colSpan={10} style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>
                <i className="fa fa-spinner fa-spin" style={{ fontSize:22, display:'block', marginBottom:8 }} />Loading homebases…
              </td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={10} style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>No homebases found</td></tr>
            ) : filtered.map((row, i) => {
              const sel = selectedIds.includes(row.homebaseCode);
              return (
                <tr key={row.homebaseCode} className={`em-tr${sel?' selected':''}`}
                  style={{ animation:`emFadeUp 0.3s ${Math.min(i,20)*0.018}s ease-out both` }}>
                  <td className="em-td"><input type="checkbox" checked={sel} onChange={() => toggleSelect(row.homebaseCode, row)} /></td>
                  <td className="em-td" style={{ color:'#64748b', fontSize:12 }}>{row.homebaseCode}</td>
                  <td className="em-td" style={{ fontWeight:600 }}>{row.homebaseName}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.homebaseType===1||row.homebaseType==='1'?'Homebase':row.homebaseType}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.teams}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.city}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.contactPerson}</td>
                  <td className="em-td" style={{ fontSize:11 }}>{row.latitude}</td>
                  <td className="em-td" style={{ fontSize:11 }}>{row.longitude}</td>
                  <td className="em-td">
                    <button className="em-btn em-btn-ghost" style={{ padding:'5px 10px', fontSize:11 }} onClick={() => openEdit(row)}>
                      <i className="fa fa-pencil" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div style={{ padding:'10px 16px', background:'#f8fafc', borderTop:'1px solid #e8edf2', fontSize:12, color:'#94a3b8', fontWeight:600 }}>
        {filtered.length} homebase{filtered.length!==1?'s':''}
      </div>

      {drawerOpen && (
        <>
          <div className="em-overlay" onClick={closeDrawer} />
          <div className="em-drawer">
            <div className="em-drawer-header">
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ width:36, height:36, borderRadius:11, background:'rgba(255,255,255,0.12)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <i className="fa fa-building" style={{ color:'#fff', fontSize:16 }} />
                  </div>
                  <div>
                    <p className="em-drawer-title">{isEdit ? 'Edit Homebase' : 'Add New Homebase'}</p>
                    <p className="em-drawer-sub">{isEdit ? `Code: ${form.homebaseCode}` : 'Fill in the homebase details below'}</p>
                  </div>
                </div>
                <button onClick={closeDrawer} style={{ background:'rgba(255,255,255,0.1)', border:'none', borderRadius:10, width:30, height:30, cursor:'pointer', color:'#fff', fontSize:18, display:'flex', alignItems:'center', justifyContent:'center' }}>×</button>
              </div>
            </div>
            <div className="em-drawer-body">
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Homebase Name<span className="em-req">*</span></label>
                  <input className="em-field" value={form.homebaseName||''} placeholder="e.g. Dubai Hub"
                    onChange={e => setForm(p => ({ ...p, homebaseName: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Homebase Type<span className="em-req">*</span></label>
                  <select className="em-field" value={form.homebaseType||''} onChange={e => setForm(p => ({ ...p, homebaseType: e.target.value }))}>
                    <option value="">— Select type —</option>
                    <option value="1">Homebase</option>
                  </select>
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Team<span className="em-req">*</span></label>
                  <select className="em-field" value={form.teams||''} onChange={e => setForm(p => ({ ...p, teams: e.target.value }))}>
                    <option value="">— Select team —</option>
                    {teams.map(t => <option key={t.teamId} value={t.teamId}>{t.teamName}</option>)}
                  </select>
                </div>
                <div className="em-form-row">
                  <label className="em-label">Contact Person<span className="em-req">*</span></label>
                  <input className="em-field" value={form.contactPerson||''} placeholder="e.g. John Doe"
                    onChange={e => setForm(p => ({ ...p, contactPerson: e.target.value }))} />
                </div>
              </div>
              <div className="em-form-row">
                <label className="em-label">Place Name<span className="em-req">*</span></label>
                <input className="em-field" value={form.place||''} placeholder="e.g. Al Quoz Industrial"
                  onChange={e => setForm(p => ({ ...p, place: e.target.value }))} />
              </div>
              <div className="em-form-row">
                <label className="em-label">Address<span className="em-req">*</span></label>
                <input className="em-field" value={form.address||''} placeholder="Full address"
                  onChange={e => setForm(p => ({ ...p, address: e.target.value }))} />
              </div>
              <div className="em-form-row">
                <label className="em-label">Locality<span className="em-req">*</span></label>
                <input className="em-field" value={form.locality||''} placeholder="Locality / Area"
                  onChange={e => setForm(p => ({ ...p, locality: e.target.value }))} />
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">City<span className="em-req">*</span></label>
                  <select className="em-field" value={form.city||''} onChange={e => setForm(p => ({ ...p, city: e.target.value }))}>
                    <option value="">— Select city —</option>
                    {CITIES.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div className="em-form-row">
                  <label className="em-label">Country</label>
                  <select className="em-field" value={form.country||'AE'} onChange={e => setForm(p => ({ ...p, country: e.target.value }))}>
                    {Object.entries(country_code_list()).map(([code, name]) => <option key={code} value={code}>{name}</option>)}
                  </select>
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Latitude<span className="em-req">*</span></label>
                  <input className="em-field" value={form.latitude||''} placeholder="25.2048"
                    onChange={e => setForm(p => ({ ...p, latitude: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Longitude<span className="em-req">*</span></label>
                  <input className="em-field" value={form.longitude||''} placeholder="55.2708"
                    onChange={e => setForm(p => ({ ...p, longitude: e.target.value }))} />
                </div>
              </div>
              <div className="em-form-row" style={{ maxWidth:240 }}>
                <label className="em-label">Transaction Duration</label>
                <input className="em-field" value={form.trans_dur||''} placeholder="e.g. 15 (min)"
                  onChange={e => setForm(p => ({ ...p, trans_dur: e.target.value }))} />
              </div>
              {msg    && <p className="em-msg-error">{msg}</p>}
              {errMsg && <p className="em-msg-error">{errMsg}</p>}
            </div>
            <div className="em-drawer-footer">
              <button className="em-dismiss-btn" onClick={closeDrawer}>Cancel</button>
              <button className="em-save-btn" onClick={handleSubmit}>
                <i className="fa fa-check" style={{ marginRight:6 }} />{isEdit?'Update Homebase':'Save Homebase'}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
